const views = {
  LOGIN_VIEW: 'LOGIN_VIEW',
  REGISTER_VIEW: 'REGISTER_VIEW',
  USER_DATA_VIEW: 'USER_DATA_VIEW',
  BASIC_DATA_FORM: 'BASIC_DATA_FORM',
} as const;

export default views;
